module.exports = require("@wordpress/components");